import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Modal, Row, Col} from 'react-bootstrap';
import ForgotPasswordForm from './ForgotPasswordForm';
import * as loginActions from '../../actions/loginActionCreators';

class ForgotPasswordModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit (values) {
    this.props.loginActions.resetPassword(values)
      .then(res => {
        if(res.status == 200) {
          this.props.closeModal();
        }
      });
  }

  render(){
    return (
      <Modal show={this.props.showModal} onHide={this.props.closeModal} className="addConflictModal">
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                Forgot password?
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Enter your email</p>
          <ForgotPasswordForm
              onSubmit={this.handleSubmit}
              initialValues={{email: this.props.initialValue != '' ? this.props.initialValue : null}}
            />
        </Modal.Body>
      </Modal>
    );
  }
}

ForgotPasswordModal.propTypes = {
  //myProp: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    form: state.form
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loginActions: bindActionCreators(loginActions, dispatch)
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(ForgotPasswordModal);



// WEBPACK FOOTER //
// ./src/components/login/ForgotPasswordModal.js